<div>
<form [formGroup]="form" class="flex-row">
    <div>
        <mat-form-field style="width: 400px;"   [appearance]="inputBgColor ? 'fill' : 'outline'"
        [ngStyle]="inputBgColor ? {
            '--mdc-filled-text-field-container-color': inputBgColor,
            '--mdc-filled-text-field-active-indicator-color': 'transparent',
            '--mdc-filled-text-field-focus-active-indicator-color': 'transparent',
            '--mdc-filled-text-field-disabled-active-indicator-color': 'transparent'
          } : null">
            <input matInput [formControlName]="ADDRESS_STREET" type="text" #addressinput
                [placeholder]="('shared.address-input.buscar-una-direccion-valida' | exp:'':'Buscar una dirección válida')" (change)="this.changes.emit()" (click)="selectAll()"
                [disabled]="!enabledForm" />
            <mat-error *ngIf="form.get(ADDRESS_STREET)?.hasError('invalid')">
                {{ 'shared.address-input.busque-y-seleccione-una-direccion-valida' | exp:'':'Busque y seleccione una dirección válida' }}
            </mat-error>
        </mat-form-field>
    </div>

    <div class="flex-column checkbox-error-wrapper">
        <app-checkbox-input [form]="form" [label]="('shared.address-input.sin-numero' | exp:'':'Sin número')" [name]="this.ADDRESS_WITHOUT_NUMBER"
            [customError]="!form.get(ADDRESS_WITHOUT_NUMBER)?.valid && form.get(ADDRESS_WITHOUT_NUMBER)?.touched"
            [customErrorMessage]="('shared.address-input.confirmar-sin-numero' | exp:'':'Confirmar Sin número')">
        </app-checkbox-input>
    </div>
</form>
</div>
